import React, { Component } from 'react';
import { translate } from "../../i18n/customI18nProvider";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { formatNumber } from '../../util';

class EntranceCount extends Component {

    max_allowed_height = 750;
    page_height = 1600;

    componentDidMount() {
        const element = document.getElementById('entrance_count_chart');
        const element_print = document.getElementById('entrance_count_chart_print');
        if (element && element_print) {
            // console.log(element.offsetHeight);
            if (element.offsetHeight > this.max_allowed_height) {
                let times = Math.ceil(element.offsetHeight / this.page_height);
                element_print.style.marginTop = this.max_allowed_height + 100 + "px";
                element_print.style.height = (times * this.page_height) - 100 - ((times - 1) * 100) + "px";
            } else if (element.offsetHeight <= this.max_allowed_height) {
                element_print.style.marginBottom = this.max_allowed_height - element.offsetHeight + 50 + "px";
            }
        }
    }

    render() {

        const { clients, entrances } = this.props;

        let result = [];

        const row_data = [];
        const total = {
            "daywise_entrances": 0,
            "daywise_people": 0,
            "entrances": 0
        };

        for (let i = 0; i < clients?.length; i++) {
            if (clients[i].date === 'unusedActivatedClients') {
                row_data.unshift({
                    daywise_entrances: clients[i].count,
                    date: translate('custom.unused_activated_clients'),
                    daywise_people: 0,
                    day: 0
                });
            } else {
                let obj = {
                    daywise_entrances: clients[i].count,
                    date: (new Date(clients[i].date)).toLocaleDateString(translate('custom.OPTIONS.i18n_date_format'), { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
                    daywise_people: result[i] ? result[i] : 0,
                    day: i + 1
                };
                total["daywise_entrances"] += obj["daywise_entrances"];
                total["daywise_people"] += obj["daywise_people"];
                row_data.push(obj);
            }
        }

        for (let i = 0; i < entrances?.length; i++) {

            let obj = {
                entrance_name: entrances[i].name + (entrances[i].is_bracelet_used === false ? ' (' + translate('custom.unused').toLowerCase() + ')' : ''),
                entrances: entrances[i].total
            };

            if (row_data[i]) {
                Object.assign(row_data[i], obj);
            } else {
                row_data[i] = obj;
            }

            total["entrances"] += entrances[i].total;
        }


        if (clients && row_data.length > 0) {
            return (
                <div className="breakBefore" style={{ maxWidth: 850, marginLeft: "auto", marginRight: "auto", marginTop: 50 }}>
                    <h1 className={this.props.classes.titleTextStyle}>{translate('custom.entrance_count')}</h1>
                    <Box overflow="auto">
                        <Table style={{ marginBottom: 20 }} >
                            <TableBody className={this.props.classes.table_head} >
                                <TableRow>
                                    <TableCell className={this.props.classes.table_head} style={{ width: '30%' }}></TableCell>
                                    <TableCell className={this.props.classes.table_head}>{translate('custom.date')}</TableCell>
                                    <TableCell className={this.props.classes.table_head}></TableCell>
                                    <TableCell className={this.props.classes.table_head}>{translate('custom.entrances')}</TableCell>
                                </TableRow>
                            </TableBody>
                            <TableBody>
                                {row_data.map((r_data, r_idx) => (
                                    <TableRow
                                        key={r_idx}
                                    >
                                        <TableCell className={this.props.classes.table_numeric} numeric="true">{('daywise_entrances' in r_data) ? formatNumber(r_data["daywise_entrances"]) : ''}</TableCell>
                                        <TableCell className={this.props.classes.table_row}>{('date' in r_data) ? r_data["date"] : ''}</TableCell>
                                        <TableCell className={this.props.classes.table_numeric} numeric="true">{'entrances' in r_data ? formatNumber(r_data["entrances"]) : ''}</TableCell>
                                        <TableCell className={this.props.classes.table_row}>{('entrance_name' in r_data ? r_data["entrance_name"] : '')}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableBody className={this.props.classes.table_head} >
                                <TableRow>
                                    <TableCell className={this.props.classes.table_head_numeric} numeric="true">{formatNumber(total["daywise_entrances"])}</TableCell>
                                    <TableCell className={this.props.classes.table_head}>{translate('custom.total_daywise_entrances')}</TableCell>
                                    <TableCell className={this.props.classes.table_head_numeric} numeric="true">{formatNumber(total["entrances"])}</TableCell>
                                    <TableCell className={this.props.classes.table_head}>{translate('custom.total_entrances')}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                </div>
            );
        }
        return null;
    }
}

const styles = theme => ({
    table_head: {
        backgroundColor: theme.palette.primary.main,
        fontWeight: "bold",
        fontSize: 15,
        color: theme.palette.primary.contrastText,
    },
    table_head_numeric: {
        textAlign: 'right',
        backgroundColor: theme.palette.primary.main,
        fontWeight: "bold",
        fontSize: 15,
        color: theme.palette.primary.contrastText
    },
    table_numeric: {
        textAlign: 'right',
        fontSize: 15
    },
    table_row: {
        fontSize: 15
    },
    titleTextStyle: {
        color: theme.palette.primary.main,
        fontSize: 24,
        bold: true,
        marginBottom: 15
    }
});

export default withStyles(styles)(EntranceCount);